import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export type Txn = {
  id: string; reference: string; amount: number; currency: string;
  status: "pending" | "success" | "failed" | "refunded";
  product_kind: "focus_package" | "intl_package" | "cbt_plan";
  product_id: string; created_at: string; verified_at: string | null;
};

export function useMyTransactions() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["my-transactions", user?.id],
    enabled: !!user,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("payment_transactions").select("*")
        .eq("user_id", user!.id).order("created_at", { ascending: false });
      if (error) throw error;
      return (data ?? []) as Txn[];
    },
  });
}

export function useMyIntlEntitlements(opts?: { includeArchived?: boolean }) {
  const { user } = useAuth();
  const includeArchived = !!opts?.includeArchived;
  return useQuery({
    queryKey: ["my-intl-ent", user?.id, includeArchived],
    enabled: !!user,
    queryFn: async () => {
      let q = supabase.from("student_entitlements").select("intl_package_id")
        .eq("user_id", user!.id).not("intl_package_id", "is", null);
      if (!includeArchived) q = q.eq("is_archived", false);
      const { data, error } = await q;
      if (error) throw error;
      return (data ?? []).map((r) => r.intl_package_id as string);
    },
  });
}
